module.exports = __webpack_public_path__ + "z/proximanova-regularit-webfont.cd372de3.svg";